export const WATCHANIME_RED = "#FF0000";

export const HEADER_VIDEO_CONTAINER_HEIGHT = "56.25vw";
export const HEADER_VIDEO_CONTAINER_HEIGHT_MIN = 700;

export const ANIME_SLIDER_WIDTH = "270px";
export const ANIME_SLIDER_MOBILE_WIDTH = "270px";
export const ANIME_SLIDER_GAP = "20px";
